export default __webpack_public_path__ + "static/media/trafficIcon.dacda60d.svg";